<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>进项票</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.channelId" placeholder="请选择公司" filterable>
					<el-option key="" label="请选择公司" value=""></el-option>
					<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.invoiceNo" placeholder="发票号" class="handle-input mr10" style="width:200px"></el-input>
				<el-select v-model="query.deduction" placeholder="请选择抵扣类型" style="width:150px">
					<el-option key="" label="请选择抵扣类型" value=""></el-option>
					<el-option key="true" label="已抵扣" value="true"></el-option>
					<el-option key="false" label="未抵扣" value="false"></el-option>
				</el-select>&nbsp;
				<el-date-picker
					type="month"
					placeholder="抵扣开始期号"
					v-model="query.deductionPeriodStart"
					value-format="yyyy-MM"
					style="width:150px;"
				></el-date-picker>&nbsp;
				<el-date-picker
					type="month"
					placeholder="抵扣结束期号"
					v-model="query.deductionPeriodEnd"
					value-format="yyyy-MM"
					style="width:150px;"
				></el-date-picker>&nbsp;&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>&nbsp;&nbsp;
				<a href="https://img.zelixin.cn/template/进项票导入模板.xlsx" style="font-size:12px;color:#66b1ff">进项票模板</a>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center" :selectable="isSelectable"></el-table-column>
                <el-table-column prop="channelName" label="公司名称"></el-table-column>
				<el-table-column prop="invoiceCode" label="发票编码" width="120"></el-table-column>
				<el-table-column prop="invoiceNo" label="发票号" width="200"></el-table-column>
				<el-table-column prop="invoiceAccount" label="未税金额" width="100"></el-table-column>
				<el-table-column prop="invoiceAccountTax" label="含税金额" width="100"></el-table-column>
				<el-table-column prop="invoiceDate" label="开票日期" width="120"></el-table-column>
				<el-table-column prop="deductionPeriod" label="抵扣期号" width="120">
					<template slot-scope="scope">
						{{scope.row.deduction?scope.row.deductionPeriod:(scope.row.invoiceNo=="合计："?scope.row.deductionPeriod:"未抵扣")}}
					</template>
				</el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit'] && scope.row.invoiceNo != '合计：'"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show'] && scope.row.invoiceNo != '合计：'"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete'] && scope.row.invoiceNo != '合计：'"
                        >删除</el-button>
						<div v-if="scope.row.invoiceNo == '合计：'">
							{{scope.row.total2}}
						</div>
                    </template>
					
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
					style="float:left"
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
				<el-upload
					style="float:left"
					class="upload-demo mr10"
					accept=".xls,.xlsx"
					action= "/blob/income/import-excel"
					:on-success="uploadSuccess"
					:file-list="fileList"
					:show-file-list = "false"
					v-if="controll['import']"
					list-type="picture">
					<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入进项票记录</el-button>
				</el-upload>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="addVisible" width="70%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-row>
					<el-col :span = "6">
						<el-form-item label="开票公司" prop="channelId" >
							<el-select v-model="form.channelId" placeholder="请选择公司" filterable @change = getOrderData>
								<el-option key="" label="请选择公司" value=""></el-option>
								<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="" prop="isMultiple">
							<el-checkbox v-model="form.isMultiple" placeholder="多票组合">多票组合</el-checkbox>
						</el-form-item>
						<el-form-item label="发票编码" prop="invoiceCode">
							<el-input v-model="form.invoiceCode"></el-input>
						</el-form-item>
						<el-form-item label="发票号" prop="invoiceNo">
							<el-input v-model="form.invoiceNo"></el-input>
						</el-form-item>
						<el-form-item label="开票日期" prop="invoiceDate">
							<el-date-picker
								type="date"
								placeholder="请选择开票日期"
								v-model="form.invoiceDate"
								value-format="yyyy-MM-dd"
								style="width:155px;"
							></el-date-picker>
						</el-form-item>
						<el-form-item label="未税金额" prop="invoiceAccount">
							<el-input v-model="form.invoiceAccount"></el-input>
						</el-form-item>
						<el-form-item label="含税金额" prop="invoiceAccountTax">
							<el-input v-model="form.invoiceAccountTax"></el-input>
						</el-form-item>
						<el-button type="primary" @click="addIncome" v-prevent-re-click v-if="form.isMultiple" style="float:right">添加</el-button>
					</el-col>
					<el-col :span = "18">
						<div style="margin-left:20px;">
							<el-table
								:data="orderData"
								border
								class="table"
								ref="multipleTable"
								header-cell-class-name="table-header"
								@selection-change="handleOrderDataSelectionChange"
								:cell-style="{padding:4+'px'}"
								height="330px"
								stripe
							>
								<el-table-column type="selection" width="55" align="center"></el-table-column>
								<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
								<el-table-column prop="orderCompanyName" label="供货公司"></el-table-column>
								<el-table-column prop="total" label="数量" width="60"></el-table-column>
								<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
								<el-table-column prop="status" label="订单状态" :formatter="statusFormat" width="80"></el-table-column>
								<el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
								</el-table-column>
							</el-table>
							<div style="width:100%;text-align:right">选中金额：{{selectMoney}}元</div>
							<el-tag
								v-for="tag in incomeTags"
								:key="tag"
								class="mx-1"
								closable
								:disable-transitions="false"
								@close="tagClose(tag)"
								v-if="form.isMultiple"
								size="large"
								style="margin-bottom:20px;margin-right:10px;"
							  >
								<a v-on:dblclick="tagDblClick(tag)">{{ tag.invoiceCode + " - " + tag.invoiceNo + " ( ￥" + tag.invoiceAccountTax + " ) " }}</a>
							</el-tag>
						</div>
					</el-col>
				</el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="编辑" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="100px" :rules="editRules">
				<el-form-item label="开票公司" prop="channelId" >
					<el-select v-model="form.channelId" placeholder="请选择公司" disabled="disabled">
						<el-option key="" label="请选择公司" value=""></el-option>
						<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="发票编码" prop="invoiceCode">
					<el-input v-model="form.invoiceCode"></el-input>
				</el-form-item>
				<el-form-item label="发票号" prop="invoiceNo">
					<el-input v-model="form.invoiceNo"></el-input>
				</el-form-item>
				<el-form-item label="开票日期" prop="invoiceDate">
					<el-date-picker
						type="date"
						placeholder="请选择开票日期"
						v-model="form.invoiceDate"
						value-format="yyyy-MM-dd"
						style="width:180px;"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="未税金额" prop="invoiceAccount">
					<el-input v-model="form.invoiceAccount" disabled="disabled"></el-input>
				</el-form-item>
				<el-form-item label="含税金额" prop="invoiceAccountTax">
					<el-input v-model="form.invoiceAccountTax" disabled="disabled"></el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" fullscreen>
            <el-table
                :data="previewData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
				height="600px"
				@cell-dblclick = "handleDblAdd"
            >
                <el-table-column prop="no" label="数电票号码" width="185"></el-table-column>
				<el-table-column prop="companyName" label="销方名称"></el-table-column>
				<el-table-column prop="operateDate" label="开票日期" width="120"></el-table-column>
				<el-table-column prop="amountWithoutTax" label="未税金额" width="100"></el-table-column>
				<el-table-column prop="tax" label="税额" width="100"></el-table-column>
				<el-table-column prop="amount" label="价税合计" width="100"></el-table-column>
				<el-table-column prop="incomeType" label="发票票种" ></el-table-column>
				<el-table-column prop="status" label="发票状态" width="100"></el-table-column>
				<el-table-column prop="operater" label="开票人" width="100"></el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
        </el-dialog>
		
		
		<!-- 编辑弹出框 -->
        <el-dialog title="发票内容" :visible.sync="showVisible" width="80%">
			<el-form ref="showData" :model="showData" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="2" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							发票类型
						</template>
						{{showData.typeName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							开票日期
						</template>
						{{showData.invoiceDate}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							发票编码
						</template>
						{{showData.invoiceCode}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							发票号
						</template>
						{{showData.invoiceNo}}
					</el-descriptions-item>
					
					<el-descriptions-item>
						<template slot="label">
							购买方
						</template>
						{{showData.buyerName}}<br>
						{{showData.buyerTaxNo}}<br>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							销售方
						</template>
						{{showData.salerName}}<br>
						{{showData.salerTaxNo}}<br>
					</el-descriptions-item>
				</el-descriptions>
				<el-row style="margin-top:20px;">
					<el-col :span="24">
						<el-table
							:data="showDetails"
							border
							class="table"
							header-cell-class-name="table-header"
							:cell-style="{padding:2+'px',paddingTop:6+'px',paddingBottom:6+'px'}"
							stripe
							:span-method="arraySpanMethod"
						>
							<el-table-column prop="taxCode" label="税收分类编码" width="180"></el-table-column>
							<el-table-column prop="name" label="货物或应税劳务、服务名称" width="250"></el-table-column>
							<el-table-column prop="model" label="规格型号"></el-table-column>
							<el-table-column prop="unit" label="单位" width="50"></el-table-column>
							<el-table-column prop="num" label="数量" width="80"></el-table-column>
							<el-table-column prop="price" label="单价" width="160"></el-table-column>
							<el-table-column prop="amount" label="金额"></el-table-column>
							<el-table-column prop="rate" label="税率" width="60"></el-table-column>
							<el-table-column prop="taxAmount" label="税额"></el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showVisible = false">关  闭</el-button>
			</span>
			
		</el-dialog>
		
    </div>
</template>

<script>
import { getTime } from '../../../utils/common';
import { getControll } from '../../../utils/controlls';
import { getNoInvoicePurchaseOrders, fetchIncomeData, saveIncome, deleteIncome, getIncome, getChannelKV, 
getIncomeContent, updateIncome} from '../../../api/index';
export default {
    name: 'income',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
			multipleSelectionOrderData:[],
            addVisible: false,
            pageTotal: 0,
            form: {},
			showData: {},
			showDetails: [],
			title:"",
			productTypeEnumCode:1003,
			productTypeKV:{},
			channelsKV:{},
			productOptions:[],
			activeName:"table",
			showVisible:false,
			content:{},
			rules:{
				channelId:[{ required: true, message: '请选择开票公司', trigger: 'blur' }],
				invoiceCode:[{ required: true, message: '发票编码不能为空', trigger: 'blur' }],
				invoiceNo:[{ required: true, message: '发票号不能为空', trigger: 'blur' }],
				invoiceDate:[{ required: true, message: '开票日期不能为空', trigger: 'blur' }],
				invoiceAccount:[{ required: true, message: '未税金额不能为空', trigger: 'blur' }],
				invoiceAccountTax:[{ required: true, message: '含税金额不能为空', trigger: 'blur' }]
			},
			editVisible:false,
			editRules:{
				channelId:[{ required: true, message: '请选择开票公司', trigger: 'blur' }],
				invoiceCode:[{ required: true, message: '发票编码不能为空', trigger: 'blur' }],
				invoiceNo:[{ required: true, message: '发票号不能为空', trigger: 'blur' }],
				invoiceDate:[{ required: true, message: '开票日期不能为空', trigger: 'blur' }],
				invoiceAccount:[{ required: true, message: '未税金额不能为空', trigger: 'blur' }],
				invoiceAccountTax:[{ required: true, message: '含税金额不能为空', trigger: 'blur' }]
			},
			orderData:[],
			incomeTags:[],
			tagIndex:1,
			selectMoney:0,
			previewVisible:false,
			previewData:[],
			uuid:"",
			fileList:[],
			controll:{},
		}
	},
    created() {
		this.controll = getControll("income");
		this.getChannels();
        this.getData();
    },
    methods: {
		//删除记录标签
		tagClose(tag) {
			let index = this.incomeTags.findIndex(item => {
				if (item.index === tag.index) {
					return true;
				}
			});
			if (index === -1) return;
			this.incomeTags.splice(index, 1);
		},
		tagDblClick(tag) {
			this.$set(this.form, "channelId", tag.channelId);
			this.$set(this.form, "invoiceCode", tag.invoiceCode);
			this.$set(this.form, "invoiceNo", tag.invoiceNo);
			this.$set(this.form, "invoiceDate", tag.invoiceDate);
			this.$set(this.form, "invoiceAccount", tag.invoiceAccount);
			this.$set(this.form, "invoiceAccountTax", tag.invoiceAccountTax);
		},
		isSelectable(row, index) {
			return row.invoiceNo != '合计：';
		},
		//添加进项票记录和标签
		addIncome() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let index = this.incomeTags.findIndex(item => {
						if (item.invoiceCode === this.form["invoiceCode"] && item.invoiceNo === this.form["invoiceNo"] ) {
							return true;
						}
					});
					if (index > -1) {
						this.$confirm('进项票已添加，是否执行更新？', '提示', {
							type: 'warning'
						}).then(() => {
							let invoiceIndex = this.incomeTags[index]["index"];
							this.incomeTags.splice(index, 1);
							this.setInvoiceData(invoiceIndex);
						});
					} else {
						this.tagIndex = this.tagIndex + 1;
						this.setInvoiceData(this.tagIndex);
					}
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		setInvoiceData(index) {
			let income = {};
			income["channelId"] = this.form["channelId"];
			let channelIndex = this.channelsKV.findIndex(item => {
				if (item.key === this.form["channelId"]) {
					return true;
				}
			})
			income["channelName"] = this.channelsKV[channelIndex].value;
			income["invoiceCode"] = this.form["invoiceCode"];
			income["invoiceNo"] = this.form["invoiceNo"];
			income["invoiceDate"] = this.form["invoiceDate"];
			income["invoiceAccount"] = this.form["invoiceAccount"];
			income["invoiceAccountTax"] = this.form["invoiceAccountTax"];
			income["index"] = index;
			this.incomeTags.push(income);
			this.$set(this.form, "invoiceNo", "");
			this.$set(this.form, "invoiceDate", "");
			this.$set(this.form, "invoiceAccount", "");
			this.$set(this.form, "invoiceAccountTax", "");
		},
		statusFormat(row, column, cellValue) {
			let statusConfig = {"0":"待审核","1":"待付款","2":"待收货","3":"收货中","4":"已到货","5":"已完结","6":"已撤销"};
			return statusConfig[cellValue];
		},
		//获取渠道
		getChannels() {
			getChannelKV().then(res => {
				if (res.code == 0) {
					this.channelsKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
		getChildrenLabel(children, index, names) {
			for (var i = 0; i < children.length; i++) {
				if (children[i].value === this.detail["productInfo"][index]) {
					names.push(children[i].label);
					if (null != children[i].children) {
						index ++;
						return this.getChildrenLabel(children[i].children, index, names);
					}
				}
			}
		},
        // 获取数据
        getData() {
            fetchIncomeData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
					let invoiceAccount = 0;
					let invoiceAccountTax = 0;
					let summary = {};
					summary["invoiceNo"] = "合计：";
					for (var i = 0; i < res.data.records.length; i++) {
						invoiceAccount += res.data.records[i]["invoiceAccount"];
						invoiceAccountTax += res.data.records[i]["invoiceAccountTax"];
					}
					summary["invoiceAccount"] = invoiceAccount.toFixed(2);
					summary["invoiceAccountTax"] = invoiceAccountTax.toFixed(2);
					if (res.data.tatistics) {
						summary["invoiceDate"] = "总计：";
						summary["deductionPeriod"] = res.data.tatistics["invoiceAccount"];
						summary["total2"] = res.data.tatistics["invoiceAccountTax"];
					}
					this.tableData.push(summary);
				} else {
					this.$message.error(res.message);
				}
            });
        },
		getOrderData(val) {
			if (val == undefined || val == "") {
				return;
			}
            getNoInvoicePurchaseOrders(val).then(res => { 
				if (res.code == 0 ) {
					this.orderData = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteIncome([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		handleOrderDataSelectionChange(val) {
			this.multipleSelectionOrderData = val;
			const length = this.multipleSelectionOrderData.length;
			let smoney = 0;
            for (let i = 0; i < length; i++) {
				smoney = smoney + this.multipleSelectionOrderData[i].amount;
            }
			this.selectMoney=smoney;
		},
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteIncome(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		
		handleDblAdd(row) {
			let channelIndex = this.channelsKV.findIndex(item => {
				if (item.value === row["companyName"]) {
					return true;
				}
			})
			if (channelIndex != -1) {
				this.$set(this.form, "channelId", this.channelsKV[channelIndex].key);
				this.getOrderData(this.channelsKV[channelIndex].key);
			}
			this.$set(this.form, "invoiceNo", row['no']);
			this.$set(this.form, "invoiceDate", row['operateDate']);
			this.$set(this.form, "invoiceAccount", row['amountWithoutTax']);
			this.$set(this.form, "invoiceAccountTax", row['amount']);
			this.$set(this.form, "channelTaxNo", row['taxNo']);
			this.showAddDialog();
		},
		//添加操作
		handleAdd() {
			this.form = {};
			this.uuid = "";
			this.showAddDialog();
		},
		showAddDialog() {
			this.$set(this.form, 'isMultiple', false);
			this.$set(this.form, 'invoiceCode', "全电发票");
			this.selectMoney=0;
			this.incomeTags = [];
			this.orderData = [];
			this.title = "添加新纪录";
			this.addVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			this.title = "编辑";
			this.uuid = "";
			getIncome(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        save() {
			const length = this.multipleSelectionOrderData.length;
			if (length == 0) {
				this.$message.error(`请选择需要绑定的订单！`);
				return;
			}
            let ids = [];
			let selectAmount = 0;
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelectionOrderData[i].id)
				selectAmount = selectAmount + this.multipleSelectionOrderData[i].amount;
            }
			
			if (this.form.isMultiple) {
				if (this.incomeTags.length == 0) {
					this.$message.error(`没有进项票标签记录！`);
					return;
				}
				let invoiceAmount = 0;
				for(let i = 0; i < this.incomeTags.length; i ++) {
					this.incomeTags[i]["orderIdList"] = ids;
					this.incomeTags[i]["uuid"] = this.uuid;
					invoiceAmount = invoiceAmount + Number(this.incomeTags[i]["invoiceAccountTax"]);
				}
				if (selectAmount != invoiceAmount) {
					this.$message.error(`订单记录金额和进项票金额不一致！`);
					return;
				}
				this.submitIncome(this.incomeTags);
			} else {
				this.$refs.form.validate(valid => {
					if (valid) {
						if (selectAmount != this.form["invoiceAccountTax"]) {
							this.$message.error(`订单记录金额和进项票金额不一致！`);
							return;
						}
						let index = this.channelsKV.findIndex(item => {
							if (item.key === this.form["channelId"]) {
								return true;
							}
						})
						this.form["channelName"] = this.channelsKV[index].value;
						this.form["orderIdList"] = ids;
						let submitForm = [];
						this.form["uuid"] = this.uuid;
						submitForm.push(this.form);
						this.submitIncome(submitForm);
					} else {
						this.$message.error('数据信息不完整！');
					}
				});
			}
        },
		saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let index = this.channelsKV.findIndex(item => {
						if (item.key === this.form["channelId"]) {
							return true;
						}
					})
					this.form["channelName"] = this.channelsKV[index].value;
					updateIncome(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		//提交保存请求
		submitIncome(submitForm) {
			saveIncome(submitForm).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.addVisible = false;
					this.getData();
					if (this.previewVisible) {
						for(var i = 0; i < submitForm.length; i++) {
							let index = this.previewData.findIndex(item => {
							//&& item['operateDate'] == submitForm[i]["invoiceDate"] && item["amount"] == submitForm[i]["invoiceAccountTax"]
								if(item['no'] == submitForm[i]['invoiceNo'] ) {
									return true;
								}
							})
							if (index > -1) {
								this.previewData.splice(index, 1);
							}
						}
					}
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
		},
		// 编辑操作
        handleShow(index, row) {
			this.title = "编辑";
			getIncomeContent(row.id).then(res => {
				if (res.code == 0) {
					this.content = res.data;
					this.showData = this.content.data;
					this.showDetails = this.content.details;
					if (this.showData["invoiceDate"]) {
						this.showData["invoiceDate"] = getTime(this.showData.invoiceDate, "yyyy-MM-dd");
					}
					let subtotal = {};
					subtotal["taxCode"] = "合计";
					subtotal["amount"] = this.showData.invoiceAmount;
					subtotal["taxAmount"] = this.showData.invoiceTaxAmount;
					this.showDetails.push(subtotal);
					let total = {};
					total["taxCode"] = "税价合计";
					total["model"] = this.showData.invoiceTotalAmountChina;
					total["unit"] = this.showData.invoiceTotalAmount;
					this.showDetails.push(total);
					this.showVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		arraySpanMethod({row, column, rowIndex, columnIndex}) {
			if (rowIndex === this.showDetails.length - 1) {
				// 如果是最后一行合计行,这个根据需求格子算
				if (columnIndex === 1) {
					return [1, 5];
				}
				if (columnIndex === 2) {
					return [2, 2];
				}
			}
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.previewData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
